import React from 'react';
import {Provider} from 'react-redux';
import {render} from 'react-dom';
import {Router, useRouterHistory} from 'react-router';
import createRoutes from './routes';
import configureStore from './store/configureStore';
import fetchData from './fetch-data';
import {createHistory} from 'history';
//const animatedScrollTo = require('animated-scrollto');
const basename = '/release/notes';
const initialState = window.__INITIAL_STATE__; // eslint-disable-line
const rootElement = document.getElementById('root');
import utils from './utils/utils';
import {toggleDatePickerActiveState, toggleDatePickerOpenState, datePickerStartDate, datePickerEndDate} from './actions';


const browserHistory = useRouterHistory(createHistory)({
  basename
});
const store = configureStore(initialState, browserHistory);
const routes = createRoutes(store);

function mergeObj(baseObj, addObj) {
  for (const key in addObj) {
    if ({}.hasOwnProperty.call(addObj, key)) {
      baseObj[key] = addObj[key];
    }
  }
  return baseObj;
}

function onUpdate() {

  if (window.__INITIAL_STATE__ !== null) {
    return window.__INITIAL_STATE__ = null;
  }
  window.scrollTo(0, 0);
  const {components, params} = this.state;
  const baseURL = window.basePath;
  let page = this.state.location.pathname.replace('/', '');
  if (typeof params.pageIndex !== 'undefined') {
    page = page.replace(`page/${params.pageIndex}`, '');
  }
  page = page.replace('/', '');
  page = page ? page : 'main';
  const state = store.getState();
  const tag = state.posts.tag;
  let from = utils.buildDateFormat(new Date(state.datepicker.startDate).getTime());
  let to = utils.buildDateFormat(new Date(state.datepicker.endDate).getTime());
  if (tag !== page) {
    from = utils.buildDateFormat(new Date().getTime());
    to = from;
  }
  datePickerStartDate(from);
  datePickerEndDate(to);
  const newParams = mergeObj(params, {tag: page, filter: state.search.filter, basename, baseURL, from, to});
  store.dispatch(toggleDatePickerActiveState(false));
  store.dispatch(toggleDatePickerOpenState(false));
  return fetchData(store.dispatch, components, newParams);
}

render(
  <Provider store={store}>
    <Router history={browserHistory} onUpdate={onUpdate}>
      {routes}
    </Router>
  </Provider>,
  rootElement
);



// WEBPACK FOOTER //
// ./client.js